import React from 'react';
import PropTypes from 'prop-types';

class UserLocation extends React.Component {
  static displayName = 'UserLocation';

  static propTypes = {
    onLocationChanged: PropTypes.func.isRequired,
  };

  componentDidMount() {
    if (navigator.geolocation) {
      this._watchID = navigator.geolocation.watchPosition((position) => {
        const pos = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
        this.props.onLocationChanged(pos);
      });
    }
  }

  componentWillUnmount() {
    if (this._watchID) {
      navigator.geolocation.clearWatch(this._watchID);
    }
  }

  render() {
    return null;
  }
}

export default UserLocation;



// WEBPACK FOOTER //
// ./src/ondemand/components/UserLocation.js